import React, { useContext } from 'react'

import {
  Box,
  makeAppStyles,
  IconButtonPopover,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@percept/mui'
import { Group, Settings } from '@percept/mui/icons'
import { UserPrivilegeContext } from '@percept/app-components'
import { userHasOrgPrivileges } from '@percept/utils'
import { useNavigation } from '@percept/hooks'
import { useActivePlatformUnit } from 'components/Organisation'
import { some } from 'lodash-es'

const useStyles = makeAppStyles( theme => ({
  spacedRight: {
    marginRight: theme.spacing(3),
  },
  spacedMenuIcon: {
    marginRight: theme.spacing(1.5),
  },
  managementMenuItem: {
    fontSize: 14,
    fontWeight: 500,
  },
}) )

export const PlatformAdminMenu = (): JSX.Element | null => {
  const orgUnit = useActivePlatformUnit()
  const orgUnitId = orgUnit && orgUnit.id
  const privileges = useContext(UserPrivilegeContext)

  const canViewAnalytics = userHasOrgPrivileges(
    ['org.analytics.view'],
    orgUnitId,
    privileges.org_privileges,
  )

  const adminMenuEnabled = some([
    canViewAnalytics
  ])

  const classes = useStyles()
  const navigate = useNavigation()

  if( !adminMenuEnabled ){
    return null
  }

  return (
    <IconButtonPopover
      className={classes.spacedMenuIcon}
      IconComponent={Settings}>
      <Box minWidth={300}>
        <Box p={2} display='flex' alignItems='center'>
          <Settings className={classes.spacedRight} />
          <Typography variant='h5'>Admin</Typography>
        </Box>
        <Divider />
        <List>
          {canViewAnalytics && (
            <ListItem button onClick={(): void => {
              if (orgUnitId) navigate(`/dashboards/${orgUnitId}/analytics`)
            }}>
              <ListItemIcon>
                <Group />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{className: classes.managementMenuItem}}
                primary='Analytics' />
            </ListItem>
          )}
        </List>
      </Box>
    </IconButtonPopover>
  )
}
